import React from "react";
import ReportFilterDropdown from "./ReportFilterDropdown";

const FILTER_CONFIG = [
    {
        key: "broker",
        title: "Broker",
        placeholder: "All Brokers"
    },
    {
        key: "exchange",
        title: "Exchange",
        placeholder: "All Exchanges"
    },
    {
        key: "custodian",
        title: "Custodian",
        placeholder: "All Custodians"
    },
];

function ReportFilters({
    filters = {},
    options = {},
    onChange
}) {

    const updateFilter = (key, value) => {
        onChange({
            ...filters,
            [key]: value
        });
    };

    const activeCount = Object.values(filters || {})
        .filter(v => Array.isArray(v) && v.length)
        .length;

    return (

        <div className="report-filters">

            <div className="report-filters-header">

                <h3 className="report-filters-title">
                    Filters
                </h3>

                {
                    activeCount > 0 &&
                    <div className="report-filters-count">
                        {activeCount}
                    </div>
                }

            </div>

            <div className="report-filters-body">

                {
                    FILTER_CONFIG.map(filter => (

                        <ReportFilterDropdown
                            key={filter.key}
                            label={filter.title}
                            placeholder={filter.placeholder}
                            value={filters?.[filter.key] || []}
                            options={options?.[filter.key] || []}
                            onChange={(value) =>
                                updateFilter(filter.key, value)
                            }
                        />

                    ))
                }

            </div>

        </div>

    );

}

export default ReportFilters;